import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class CharacterModel extends Component
{

    back(){
        this.props.store.storymodel = "nothing";
       
        this.forceUpdate();
        this.props.history.push("/storymodel")
    }
    character(){
        this.props.store.charactermodel = "nothing";
        this.forceUpdate();
    }
    strange(){
        this.props.store.charactermodel = "strange";
        this.forceUpdate();
    }

    knight(){
        this.props.store.charactermodel = "knight";
        this.forceUpdate();
    }

    ideal(){
        this.props.store.charactermodel = "ideal";
        this.forceUpdate();
    }

    enemy(){
        this.props.store.charactermodel = "enemy";
        this.forceUpdate();
    }

    need(){
        this.props.store.charactermodel = "need";
        this.forceUpdate();
    }

    mist(){
        this.props.store.charactermodel = "mist";
        this.forceUpdate();
    }
  
    render()
    {
        return <>
        
        {this.props.store.charactermodel == "nothing" &&  <div className = "modeltext">
        欢迎来到人物模版~<br/><br/>
        从小故事指南中，大家应该已经意识到了<br/>
        好的人物已经暗含冲突，能引导故事的走向。<br/><br/>

        为了帮大家更好的理解这一点<br/>
        这里提供三个人物模版和三个人物关系模版<br/><br/>
        
        
        人物模版：
       <br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.strange() } >怪胎</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.knight() } >骑士</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.ideal() } >执念的人</Button><br/>
       <br/> 人物关系：<br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.enemy() } >敌对</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.need() } >需要</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.mist() } >未解之谜</Button><br/>
<div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >返回模版</Button><br/>
    </div>   
    </div> }
        
    {this.props.store.charactermodel == "strange" &&<div className = "modeltext">
      <br/>  怪胎，是指和自己身份，种族，家庭环境或社会规范不相吻合的人物。
      <br/>
      因为特征怪异，天然和周围的环境相冲突<br/><br/>
      如哈利波特住在姨妈家时<br/>孙悟空西天取经之前<br/>
      鸭子群中的丑小鸭<br/>喜欢待在女孩堆里的贾宝玉<br/>
      嫁给小职员，但爱慕虚荣的玛蒂尔德<br/>
      骑士绝迹后依然深信骑士小说的唐吉坷德<br/>
      在他们的环境中，都是不折不扣的怪胎。<br/><br/>

      周围的人不理解他们，通常也不认可他们<br/>
      他们可能因为自己的怪异而痛苦，也可能不会<br/>
      但“怪异”的特征，将会把他们引领到一条与众不同的路上<br/>
      这就是我们故事的开端。<br/><br/>
      如果喜欢这个人物模版，可以试着写一个怪胎的故事。<br/><br/>


      <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>
        
        
        </div>}

        {this.props.store.charactermodel == "knight" &&<div className = "modeltext">
         <br/>   骑士通常代表着正义。<br/>
            正义，也就是守序，善良<br/>
            他们心中有着明确的规矩，并且愿意守护这样的秩序。这在动荡不安的环境中，明显是吃力不讨好的事。<br/>
            永无止境的与混乱，邪恶战斗，或许就是他们的宿命<br/>
            大部分超级英雄的故事，侦探，警匪，武侠故事，都有着一个骑士主角<br/><br/>
            如果喜欢这个人物模版，可以试着写一个骑士的故事。<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>
            </div>}


            {this.props.store.charactermodel == "ideal" &&<div className = "modeltext">
               执念的人心中，有具体且强烈的目标。<br/>
               如同在写第一个人物小故事时的“夙愿”<br/>
               但这个愿望更为强烈，能撑起一整篇故事<br/>
               故事中，人物的所有行动都是为了实现愿望<br/>
               主角努力实现愿望的步伐，组成了整个故事<br/>
               <br/>
               所有关于理想的故事，以及关于复仇的故事<br/>
               都有着这样的主角。<br/>
               如果喜欢这个人物模版，可以试着写一个执念的人的故事。<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>
               
                </div>}


                {this.props.store.charactermodel == "enemy" &&  <div className = "modeltext">
                    敌对是指故事中两个人物是敌人<br/>
                    他们或者目标相反，或者相互竞争，或者曾有过节，或者单纯看对方不顺眼<br/>
                    如同英雄和反派，主角与仇家，超级英雄和绝世恶魔<br/>
                    这样的人物关系设置非常常见<br/>
                    给主角设置对手，也是故事中增加冲突的好方法<br/>
                    只要觉得故事太平淡了，都可以简单的问一句：主角有足够强的对手吗？<br/>
                    如果没有，赶快试着加一个吧<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>


                    
                    </div>}

                    {this.props.store.charactermodel == "need" &&<div className = "modeltext">
                        需要是指故事中两个人物是互补的，相互需要的<br/>
                        这样的人物搭配常出现在爱情片中<br/>
                        他们相互需要，但中间却有着各种阻碍不能在一起<br/>
                        因而互相的需要，渴望，才一直存在<br/>
                        需要与阻碍就形成了明确的冲突<br/>
                        如果你写的是言情故事，在使用这样的人物搭配的时候<br/>
                        记得常常问自己两个问题：<br/>
                        两个主角互相需要了吗？是什么阻碍他们在一起？<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>

                        </div>}

                {this.props.store.charactermodel == "mist" &&<div className = "modeltext">
                    未解之谜是指，故事中两个人物的关系是未知的<br/>
                    这不代表他们的关系很模糊，他们的关系可能是确定的，只是读者与主角不知道<br/>
                    比如警匪故事中，不确定对方是朋友还是敌方间谍<br/>
                    言情故事中不确定对方是喜欢自己还是讨厌自己<br/>
                    这种似是而非的关系，需要探求谜底<br/>
                    而寻找谜底的过程，也是故事的看点之一<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >返回人物模版</Button><br/>
                    </div>}
        </>;
    }
} 